<button *ngIf="reportType" (click)="openReport()"
        type="button" class="btn btn-link viewReportBtn"
        [tooltip]="'View ' + reportType + ' report'"
>
  <i class="glyphicon glyphicon-file"></i>
</button>

<div class="oneNumberWidget outer text-center" style="width: 100%;  vertical-align: middle; line-height: 200px;"  *ngIf="loading">
     <img style="width: 55px;" src="img/loading200x200-1.gif" >
</div>

<div *ngIf="!loading"
     class="oneNumberWidget outer text-center" style="width: 100%; height: 200px; vertical-align: middle;">
  <div class="inner" [ngClass]="getDigitsClass()">
    <span style="line-height: 200px;"> {{value}}</span>
  </div>

  <div class="widgetText text-center">
    <span >{{'_' + reportType + 'InProgressWidget_' |translate}}</span>
  </div>
</div>